/* eslint-disable max-lines */
import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import TextField from '@base/TextField/TextField';
import { breakpoints, Fonts, Spacings, mediaQuery } from '@styles/index';
import NumberField from '@base/NumberField/NumberField';
import Checkbox from '@material-ui/core/Checkbox';
import P2 from '@base/P2/P2';
import H5 from '@base/H5/H5';
import H6 from '@base/H6/H6';
import H7 from '@base/H7/H7';
import NImage from '@base/Image';

export const Img = styled.img`
  user-drag: none;
  user-select: none;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  column-gap: 16px;
`;

export const StyledHeader = styled.header`
  background: var(--color-i-white);
  position: fixed;
  top: 0;
  left: 0;
  height: 72px;
  z-index: 1000;
  box-shadow: 0px 8px 16px rgba(221, 230, 237, 0.4);
  width: 100%;
  ${mediaQuery.uptoTablet} {
    height: 56px;
  }
`;

export const HeaderContainer = styled.nav`
  width: 1136px;
  margin: auto;
  height: 72px;
  display: flex;
  align-items: center;
  ${mediaQuery.uptoTablet} {
    width: 728px;
    height: 56px;
    padding: 0 16px;
  }
`;

export const Logo = styled(Img)`
  height: 24px;
  width: 130px;
`;

export const LeadGenContainer = styled.main`
  background: linear-gradient(
    180deg,
    var(--color-i-blue-11) 0%,
    var(--color-i-white) 100%
  );
  position: relative;
  grid-column: 1/25;
  ${mediaQuery.uptoMobile} {
    padding: 0 16px 40px;
    display: block;
  }
`;

export const Illo = styled(Img)`
  width: 112px;
  height: 78px;
  ${mediaQuery.uptoMobile} {
    position: absolute;
    right: 0;
    top: 24px;
    margin-right: -16px;
  }
`;

export const LeadGenCoverContainer = styled.section`
  display: grid;
  grid-column: span 24;
`;

export const LeadGenCoverContent = styled.div`
  position: relative;
  max-width: 294px;
  grid-column: 3/12;
  ${mediaQuery.aboveTablet} {
    max-width: 360px;
  }
  ${mediaQuery.uptoTablet} {
    grid-column: 1/11;
  }
  ${mediaQuery.uptoMobile} {
    margin-top: 0px;
    max-width: 100%;
    width: 100%;
  }
`;

export const LeadGenWrapper = styled(Grid)`
  grid-column: span 24;
  padding: 80px 0;
  ${mediaQuery.uptoTablet} {
    padding: 64px 0;
  }
  ${mediaQuery.uptoMobile} {
    display: flex;
    column-gap: 0;
    flex-direction: column;
    padding: ${({ $form }) => ($form ? '0' : '40px 16px 40px')};
    align-items: flex-start;
    background: linear-gradient(
      180deg,
      var(--color-i-blue-11) 0%,
      var(--color-i-white) 100%
    );
  }
`;

export const LeadGenContent = styled.div`
  width: 1136px;
  margin: auto;
  ${mediaQuery.uptoTablet} {
    width: 728px;
  }
`;

const H1 = styled.h1`
  color: var(--color-i-black);
  margin: 0;
`;

const P = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: var(--color-i-black);
`;

export const Title = styled.h1`
  margin: 0;
  max-width: 412px;
  margin-top: ${Spacings.SPACING_8B};
  font-size: 40px;
  line-height: 48px;
  color: var(--color-i-black);
  ${mediaQuery.aboveTablet} {
    margin-bottom: ${Spacings.SPACING_10B};
  }
  ${mediaQuery.uptoTablet} {
    margin-bottom: 12px;
    font-size: 32px;
    line-height: 38.4px;
    max-width: 260px;
  }
  ${mediaQuery.uptoMobile} {
    font-size: 28px;
    margin-top: ${Spacings.SPACING_6B};
    margin-bottom: ${Spacings.SPACING_6B};
    line-height: 33.6px;
    max-width: 100%;
  }
`;

export const SubTitle = styled(P)`
  ${mediaQuery.aboveTablet} {
    max-width: 360px;
    font-size: ${Fonts.SMALL};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
  }
  ${mediaQuery.uptoTablet} {
    max-width: 280px;
  }
`;

export const StyledPaper = styled(Paper)`
  border: 1px solid var(--color-divider);
  box-shadow: 0px 8px 16px rgba(221, 230, 237, 0.4);
  padding: 24px 16px;
  ${mediaQuery.aboveTablet} {
    max-width: 464px;
    padding: 32px 24px;
    grid-column: 13/23;
    margin: 0px;
  }
  ${mediaQuery.uptoTablet} {
    grid-column: 12/25;
  }
  ${mediaQuery.uptoMobile} {
    margin: 0;
  }
`;

export const ClassTitle = styled(H1)`
  font-size: 20px;
  line-height: 24px;
  margin-bottom: ${({ $subTitle }) => ($subTitle ? '2px' : '0px')};
`;

export const ClassSubTitle = styled.h3`
  font-size: 12px;
  line-height: 18px;
  color: var(--color-i-orange-1);
  margin-left: 4px;
  margin-bottom: 0;
`;

export const Fire = styled(Img)`
  width: 14px;
  height: 14px;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  margin-top: 12px;
  font-size: 14px;
  line-height: 50%;
  &.MuiOutlinedInput-root {
    width: 100%;
    height: 48px;
    .MuiOutlinedInput-input {
      width: 100%;
      padding: 16px 14px;
    }
  }
`;

export const StyledNumberField = styled(NumberField)`
  width: 100%;
  margin-top: 12px;
  font-size: 14px;
  line-height: 50%;
  &.MuiOutlinedInput-root {
    width: 100%;
    height: 48px;
    .MuiOutlinedInput-input {
      width: 100%;
      padding: 16px 14px;
    }
  }
`;

export const InputField = styled(TextField)`
  width: 100%;
  margin-top: ${Spacings.SPACING_3B};
  font-size: ${Fonts.SMALL};
  line-height: 50%;
  &.MuiOutlinedInput-root {
    .MuiOutlinedInput-input {
      padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B}
        ${Spacings.SPACING_4B} 0;
      ${mediaQuery.uptoMobile} {
        font-size: ${Fonts.ULTRA_SMALL};
      }
      color: var(--color-text-primary);
    }
  }
`;

export const FormContainer = styled.form`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.aboveMobile} {
    margin-top: 24px;
    & > div:nth-child(1) {
      margin: 0;
    }
  }
`;

export const ChooseClass = styled(SubTitle)`
  margin-top: ${Spacings.SPACING_8B};
  font-size: ${Fonts.SMALL};
  line-height: 21px;
  max-width: 100%;
  padding-left: 8px;
`;

export const Classes = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 8px;
  row-gap: 8px;
  margin-top: 12px;
  margin-bottom: 24px;
  ${mediaQuery.uptoTablet} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const Class = styled.button`
  height: 48px;
  border-radius: 4px;
  border: 1px solid;
  background: transparent;
  border-color: ${({ $selectedClass }) =>
    $selectedClass ? 'var(--color-i-green)' : 'var(--color-divider)'};
  color: ${({ $selectedClass }) =>
    $selectedClass ? 'var(--color-i-green)' : 'var(--color-i-gray-8)'};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  cursor: pointer;
`;

export const BookClassButon = styled.button`
  background-color: var(--color-i-green);
  height: 46px;
  color: var(--color-i-white);
  line-height: 14px;
  border: none;
  border-radius: 4px;
  font-weight: 700;
  cursor: pointer;
  display: ${({ $display }) => ($display === 'sm' ? 'none;' : 'block')};
  ${mediaQuery.uptoTablet} {
    height: 48px;
    font-size: 14px;
    line-height: 14px;
    width: 100%;
  }
  ${mediaQuery.aboveTablet} {
    ${({ height }) =>
      height === 'sm'
        ? '`height:48px;font-size:14px;line-height:14px;width:100%;`'
        : 'height:60px;font-size:20px;line-height:24px;width:192px;'}
  }
  ${mediaQuery.uptoMobile} {
    display: ${({ $display }) => ($display === 'md' ? 'none' : 'block')};
    height: 46px;
    width: 100%;
  }
`;

export const AcceptTerms = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

export const TermsBox = styled(Checkbox)`
  width: 16px;
  height: 16px;
  margin-right: 4px;
  cursor: pointer;
  &.MuiIconButton-root {
    .MuiIconButton-label {
      input {
        top: 0;
        left: 0;
        cursor: inherit;
        height: 100%;
        margin: 0;
        opacity: 0;
        padding: 0;
        z-index: 1;
        position: absolute;
      }
    }
    svg.MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
  }
`;

export const TermsContent = styled.p`
  font-size: 10px;
  line-height: 15px;
  font-weight: 600p;
`;

export const AboutTitle = styled(P2)`
  margin-bottom: ${Spacings.SPACING_6B};
  font-size: ${Fonts.LARGE};
  line-height: 22px;
  ${mediaQuery.uptoTablet} {
    font-size: 24px;
    line-height: 28.8px;
  }
  ${mediaQuery.uptoMobile} {
    font-size: 20px;
    line-height: 24px;
    margin-bottom: ${Spacings.SPACING_6B};
    font-weight: ${Fonts.SEMIBOLD};
    max-width: 235px;
  }
`;

export const AboutContent = styled(SubTitle)`
  font-weight: 600;
  ${mediaQuery.aboveTablet} {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0px;
  }
`;

export const AboutContentImg = styled(Img)`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`;

export const AboutImage = styled(Img)`
  position: absolute;
  bottom: 0;
  right: 0;
  @media only screen and (max-width: 330px) {
    width: 120px;
    z-index: -1;
  }
`;

export const FooterContainer = styled(Grid)`
  grid-column: span 24;
  margin: 180px 0 160px 0;
  align-items: center;
  ${mediaQuery.uptoTablet} {
    width: 728px;
    padding: 96px 0px;
    margin: 0 auto;
  }
  ${mediaQuery.uptoMobile} {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    margin-top: 80px;
    margin-bottom: 48px;
    align-items: flex-start;
    width: 100%;
  }
`;

export const FooterTitle = styled(ClassTitle)`
  margin-bottom: 16px;
  ${mediaQuery.aboveTablet} {
    font-size: 32px;
    line-height: 38.4px;
  }
  ${mediaQuery.uptoMobile} {
    margin-bottom: 8px;
  }
`;

export const FooterSubTitle = styled(P)`
  max-width: 318px;
  margin-bottom: 24px;
  ${mediaQuery.aboveTablet} {
    font-size: 20px;
    line-height: 30px;
  }
  ${mediaQuery.uptoMobile} {
    margin-bottom: 24px;
  }
`;

export const FooterCardTitle = styled(P)`
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 8px;
  ${mediaQuery.uptoTablet} {
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 4px;
  }
`;

export const FooterContent = styled.div`
  grid-column: 10/25;
  display: flex;
  height: 572px;
  flex-flow: column wrap;
  justify-content: center;
  ${mediaQuery.uptoTablet} {
    grid-column: 12/25;
    align-items: flex-end;
    height: 342px;
  }
  ${mediaQuery.uptoMobile} {
    height: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 8px;
    margin-bottom: 24px;
    width: 100%;
    row-gap: 8px;
  }
`;

export const FooterCard = styled(Paper)`
  box-shadow: 0px 16px 32px rgba(221, 230, 237, 0.4);
  overflow: hidden;
  position: relative;
  padding: 20px;
  width: 320px;
  height: 180px;
  display: inline-block;
  margin-bottom: ${({ $id }) => ($id === 2 ? 0 : '16px')};
  ${mediaQuery.uptoTablet} {
    width: 170px;
    height: 100px;
  }
  ${mediaQuery.uptoMobile} {
    height: 100px;
    margin-bottom: 0px;
    width: 100%;
    ${({ $id }) => ($id === 2 ? 'display:none' : '')}
  }
`;

export const FooterImage = styled(Img)`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 62px;
  height: 40px;
  ${mediaQuery.aboveTablet} {
    width: 140px;
    height: 90px;
  }
`;

export const FooterCardCover = styled.div``;

export const FooterCardDesc = styled.h4`
  font-size: 40px;
  line-height: 48px;
  font-weight: 700;
  display: inline-block;
  margin-right: 0;
  ${mediaQuery.uptoTablet} {
    font-size: 20px;
    line-height: 30px;
  }
`;
export const FooterCardCount = styled(FooterCardDesc)`
  color: var(--color-i-green);
`;

export const FooterCover = styled.div`
  grid-column: 1/8;
  ${mediaQuery.uptoTablet} {
    grid-column: 1/10;
  }
`;

export const BookAClassForm = styled.div`
  display: ${({ $display }) => ($display ? 'block' : 'none')};
`;
export const RequeestOtpForm = styled.div`
  display: ${({ $display }) => ($display ? 'block' : 'none')};
`;

export const SuccessFulCover = styled(Paper)`
  grid-column: 6/20;
  position: relative;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  column-gap: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: ${({ $isLeadGenForm }) => ($isLeadGenForm ? '64px' : '32px')};
  padding-bottom: 0;
  ${mediaQuery.uptoTablet} {
    grid-column: span 24;
    padding: 0;
    display: block;
  }
`;
export const SuccessFulContent = styled.div`
  grid-column: ${({ $isLeadGenForm }) => ($isLeadGenForm ? '6/20' : 'span 24')};
  text-align: center;
  ${mediaQuery.uptoTablet} {
    grid-column: span 24;
    padding: 0px 16px 0;
  }
`;

export const SuccessMessageTitle = styled.h1`
  color: var(--color-i-green);
  font-size: 24px;
  line-height: 28.8px;
  margin-bottom: 8px;
`;

export const SuccessMessageSubTitle = styled(P)`
  font-weight: 400;
  text-align: center;
  padding-bottom: ${({ $isLeadGenForm }) => ($isLeadGenForm ? '64px' : '32px')};
`;

export const Download = styled(Paper)`
  grid-column: ${({ $isLeadGenForm }) => ($isLeadGenForm ? '6/20' : 'span 24')};
  position: relative;
  border-radius: 0px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: ${({ $isLeadGenForm }) =>
    $isLeadGenForm ? '40px 92px' : '32px 84px'};
  ${({ $isLeadGenForm }) =>
    $isLeadGenForm
      ? ''
      : `display: block;
    text-align: center;
    place-items: center;
    grid-template-columns: repeat(12,1fr);
    column-gap: 16px;`}
  ${mediaQuery.uptoTablet} {
    grid-column: span 24;
    box-shadow: none;
    padding: 48px 16px 40px;
    display: ${({ $isLeadGenForm }) => ($isLeadGenForm ? 'grid' : 'block')};
    background: ${({ $isLeadGenForm }) =>
      $isLeadGenForm
        ? 'linear-gradient(180deg, var(--color-i-blue-11) 0%, var(--color-i-white) 100%)'
        : 'var(--color-i-white)'};
  }
  ${mediaQuery.uptoMobile} {
    display: block;
    text-align: center;
    background: ${({ $isLeadGenForm }) =>
      $isLeadGenForm ? 'none' : 'var(--color-i-white)'};
    ${({ $isLeadGenForm }) => ($isLeadGenForm ? '' : 'padding: 48px 32px 40px')}
  }
`;

export const DownloadCover = styled.div`
  grid-column: 3/22;
  ${mediaQuery.uptoTablet} {
    grid-column: 4/13;
  }
  ${mediaQuery.uptoMobile} {
    display: grid;
    place-items: center;
  }
`;
export const DownloadHeader = styled.p`
  font-size: 10px;
  line-height: 10px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--color-text-secondary);
  text-transform: uppercase;
`;
export const DownloadTitle = styled(H1)`
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 4px;
  ${mediaQuery.uptoMobile} {
    margin-top: 0;
  }
`;
export const DownloadSubTitle = styled(P)`
  font-weight: 400;
  ${mediaQuery.uptoMobile} {
    text-align: center;
  }
`;

export const PlayStoreIcon = styled.a`
  color: transparent;
  display: ${({ type, $isLeadGenForm }) =>
    type === 'appleStore' && $isLeadGenForm ? 'none' : 'block'};
  ${mediaQuery.uptoMobile} {
    margin-top: 40px;
    display: block;
  }
`;

export const DownloadContent = styled.div`
  grid-column: 14/25;
  margin-top: 16px;
  ${({ $isLeadGenForm }) => ($isLeadGenForm ? '' : 'display:grid;')}
  ${mediaQuery.uptoTablet} {
    ${({ $isLeadGenForm }) =>
      $isLeadGenForm ? '' : 'grid-template-columns:1fr;'}
  }
  ${mediaQuery.uptoMobile} {
    place-items: center;
    margin-top: 0;
  }
`;

export const AppImage = styled(NImage)`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.aboveMobile} {
    display: none;
  }
`;

export const AppImageWrapper = styled.div`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.aboveMobile} {
    display: none;
  }
`;

export const BookAClassContainer = styled.div`
  @media only screen and (min-width: ${breakpoints.mobile}) {
    grid-column: 13/25;
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

export const ConfettiContainer = styled.div`
  height: 150px;
  position: relative;
  margin: auto;
  top: -8px;
`;

export const Confetti = styled(Img)`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  height: 150px;
`;

export const Tick = styled(Img)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2;
  width: 56px;
  height: 56px;
`;

export const TermsLink = styled.a`
  text-decoration: none;
  color: var(--color-i-black);
  cursor: pointer;
`;

export const Divider = styled.div`
  position: absolute;
  top: 0;
  height: 10px;
  ${({ $isLeadGenForm }) =>
    $isLeadGenForm
      ? 'width: 100%;left: 0;'
      : 'width: calc(100% - 64px);left: 32px;'}
  box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.08);
  ${mediaQuery.uptoMobile} {
    display: ${({ $isLeadGenForm }) => ($isLeadGenForm ? 'none' : 'block')};
    ${({ $isLeadGenForm }) =>
      $isLeadGenForm ? '' : 'width: calc(100% - 32px);left: 16px;'}
  }
`;

export const AboutBlock = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${Spacings.SPACING_6B};
`;

export const AboutContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    margin-left: ${Spacings.SPACING_3B};
  }
`;

export const AboutContentTitle = styled(H5)`
  line-height: ${Fonts.PARA_LINE_HEIGHT};
`;

export const AboutContentSubTitle = styled(H6)`
  font-weight: ${Fonts.REGULAR};
  line-height: 18px;
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_1B};
`;

export const AboutImageContainer = styled.div`
  position: relative;
  height: 40px;
  width: 40px;
  ${mediaQuery.uptoMobile} {
    width: 32px;
    height: 32px;
  }
`;
export const AboutUnacademyContainer = styled.div`
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_10B};
  }
`;
export const OuterContainer = styled.div`
  background: linear-gradient(
    180deg,
    var(--color-i-blue-11) 0%,
    var(--color-i-white) 100%
  );
  min-height: 100vh;
`;
export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  column-gap: ${Spacings.SPACING_4B};
  padding-top: ${Spacings.SPACING_18B};
  width: 1136px;
  margin: auto;
  ${mediaQuery.uptoTablet} {
    width: 728px;
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding-top: 56px;
    display: block;
    column-gap: 0;
    margin-top: 0;
  }
`;

export const OTPFooter = styled.div`
  margin: ${Spacings.SPACING_4B} 0 0 0;
  display: flex;
  justify-content: center;
`;

export const OTPFooterTitle = styled(H7)`
  font-weight: ${Fonts.REGULAR};
  line-height: 16px;
  color: var(--color-text-secondary);
`;

export const OTPFooterEmail = styled.a`
  line-height: 16px;
  margin: 0 0 0 ${Spacings.SPACING_3};
  color: var(--color-base-fill);
  font-size: ${Fonts.ULTRA_SMALL};
`;

export const LeadGenImageCover = styled.div`
  width: 192px;
  height: 96px;
  position: relative;
  ${mediaQuery.uptoMobile} {
    width: 86px;
    height: 43px;
  }
`;

export const PlayStoreButton = styled.button`
  border: 0;
  background: var(--color-i-white);
  cursor: pointer;
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_10B};
    display: block;
  }
`;

export const OTPEmailText = styled.strong`
  text-decoration-line: underline;
`;
